import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-maquinas-reporte-vendedor',
  templateUrl: './maquinas-reporte-vendedor.component.html',
  styleUrls: ['./maquinas-reporte-vendedor.component.scss']
})
export class MaquinasReporteVendedorComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
